export enum SeancePointInclusNiveauType{
     None = 1,
     TypePoints,
     Matieres,
     Echevinats,
     Urgences,
     Services,
     OrdreServices
}